/// popup js

$(document).ready(function(){
    $(".icon-with-popup-section li .icon-img-sec").mouseover(function(){
                  $(this).find('img').addClass("animation-modal-icon");
                 });
  $(".icon-with-popup-section li .icon-img-sec").mouseout(function(){
                  $(this).find(' img').removeClass("animation-modal-icon");
                 });
});
  
$(document).ready(function(){
                $(".icon-with-popup-section li .icon-img-sec1 img").click(function(){
                  $('body').css('overflow','hidden');
                  $(".icon-with-popup-section .icon-popup1" ).css('display','block');
                 });
});

$(document).ready(function(){
                $(".icon-with-popup-section li .icon-img-sec2 img ").click(function(){
                  $('body').css('overflow','hidden');
                  $(".icon-with-popup-section .icon-popup2" ).css('display','block');
                 });
});
$(document).ready(function(){
                $(".icon-with-popup-section li .icon-img-sec3 img").click(function(){
                  $('body').css('overflow','hidden');
                $(".icon-with-popup-section .icon-popup3" ).css('display','block');
                 });
});
$(document).ready(function(){
                $(".icon-with-popup-section li .icon-img-sec4 img").click(function(){
                  $('body').css('overflow','hidden');
                  $(".icon-with-popup-section .icon-popup4" ).css('display','block');
                 });
});
$(document).ready(function(){
                $(".icon-with-popup-section li .icon-img-sec5 img").click(function(){
                  $('body').css('overflow','hidden');
                $(".icon-with-popup-section .icon-popup5" ).css('display','block');
                 });
});



  
  $(document).ready(function(){
                $(".icon-with-popup-section li .icon-img-sec1 button").click(function(){
                  $('body').css('overflow','unset');
                  $(".icon-with-popup-section .icon-popup1" ).css('display','none');
                 });
});

$(document).ready(function(){
                $(".icon-with-popup-section li .icon-img-sec2 button").click(function(){
                  $('body').css('overflow','unset');
                  $(".icon-with-popup-section .icon-popup2" ).css('display','none');
                 });
});
$(document).ready(function(){
                $(".icon-with-popup-section li .icon-img-sec3 button").click(function(){
                  $('body').css('overflow','unset');
                $(".icon-with-popup-section .icon-popup3" ).css('display','none');
                 });
});
$(document).ready(function(){
                $(".icon-with-popup-section li .icon-img-sec4 button").click(function(){
                  $('body').css('overflow','unset');
                  $(".icon-with-popup-section .icon-popup4" ).css('display','none');
                 });
});
$(document).ready(function(){
                $(".icon-with-popup-section li .icon-img-sec5 button").click(function(){
                  $('body').css('overflow','unset');
                $(".icon-with-popup-section .icon-popup5" ).css('display','none');
                 });
});

// popup js end